import React, { useState, useEffect, memo } from 'react';
import { Table, TableBody, TableHead, TableRow, TableCell } from '@mui/material';
import { Config } from '../../../Utils/Config';
import moment from "moment";


const LoanDetailsPdf = memo((props) => { 
   
    const [page, setPage] = useState(0);
    const [loanDetailsData, setLoanDetailsData] = useState({});


    useEffect(() => {
        if (props && props.data) {
            setLoanDetailsData(props.data);
        }
    }, [props && props.data]);

    const priceConversion = (tot) => {
        if (!tot)  return null;    
        if (tot !== "") {
          let checkDigit = tot.toString().split(".");
          let ret = "";
          let i = 0;
          if (tot.toString().indexOf(".") == -1) {
            tot = tot;
          } else {
            if (checkDigit == "00") {
              tot = checkDigit.trim();
            } else {
              if (checkDigit.length === 2) {
                ret += checkDigit[0] + ".";
                for (i = 0; i < checkDigit.length; i++) {
                  if (i >= checkDigit[1].length) ret += "0";
                  else ret += checkDigit[1][i];
                }
              } else if (checkDigit.length === 1) {
                ret += checkDigit[0] + ".";
                for (i = 0; i < checkDigit.length; i++) {
                  ret += "0";
                }
              }
              ret = ret.toString();
              tot = ret;
            }
          }
        }
        return tot.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      };
    
    return (
        <div className='valuation-debt-table'>
            <Table className='table-design'>
                <TableHead>
                    <TableRow>
                        <TableCell> Improvement Value</TableCell>
                        <TableCell>Interest Rate</TableCell>
                        <TableCell>Interest Type</TableCell>
                        <TableCell>Land Value</TableCell>
                        <TableCell>Last Sale Date</TableCell>
                        <TableCell>Last Sale Value</TableCell>
                        <TableCell>Loan Amount</TableCell>
                        <TableCell>Loan Duration</TableCell>
                        <TableCell>Loan Maturity Date</TableCell>
                        <TableCell>Loan Origination Date</TableCell>
                        <TableCell>Loan Type</TableCell>
                        <TableCell>Market Value</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Total Market Value</TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    { loanDetailsData && 
                        loanDetailsData.length > 0 ? (
                            loanDetailsData.map((data) => (
                                <TableRow>
                                    <TableCell>{data.improvementvalue !== null ? Config.Currency + priceConversion(data.improvementvalue) : "-"}</TableCell>
                                    <TableCell>{data.interestrate !== null ? priceConversion(data.interestrate) + "%" : "-"}</TableCell>
                                    <TableCell>{data.interesttype !== null ? data.interesttype : "-"}</TableCell>
                                    <TableCell>{data.landvalue !== null ? Config.Currency + priceConversion(data.landvalue) : "-"}</TableCell>
                                    <TableCell>{data.lastsaledate !== null ? moment(data.lastsaledate).format('DD-MMM-YYYY') : "-"}</TableCell>
                                    <TableCell>{data.lastsalevalue !== null ? Config.Currency + priceConversion(data.lastsalevalue) : "-"}</TableCell>
                                    <TableCell>{data.loanamount !== null ? Config.Currency + priceConversion(data.loanamount) : "-"}</TableCell>
                                    <TableCell>{data.loanduration !== null ? data.loanduration + " months" : "-"}</TableCell>
                                    <TableCell>{data.loanmaturitydate !== null ? moment(data.loanmaturitydate).format('DD-MMM-YYYY') : "-"}</TableCell>
                                    <TableCell>{data.loanoriginationdate !== null ? moment(data.loanoriginationdate).format('DD-MMM-YYYY') : "-"}</TableCell>
                                    <TableCell>{data.loantype !== null ? data.loantype : "-"}</TableCell>
                                    <TableCell>{data.marketvalue !== null ? Config.Currency + priceConversion(data.marketvalue) : "-"}</TableCell>
                                    <TableCell>{data.status !== null ? data.status : "-"}</TableCell>
                                    <TableCell>{data.totalmarketvalue !== null ? Config.Currency + priceConversion(data.totalmarketvalue) : "-"}</TableCell>


                                </TableRow>
                            ))
                    )
                    : (
                        <TableRow>
                          <TableCell colSpan={7} style={{ textAlign: "center" }} className="store-no-data">No records found</TableCell>
                        </TableRow>
                      )
                    }
                </TableBody>      
            </Table>
        </div>
    )
});

export default LoanDetailsPdf;